import { Injectable } from '@angular/core'
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { SharedConsts } from 'src/app/shared/constants';
import { SharedService } from 'src/app/shared/services/shared.service';
import { environment } from 'src/environments/environment';
import { StatePersistService } from '../services/state-persist.service';


@Injectable()

export class PublicGuard implements CanActivate {

    constructor(private router: Router, private statePersistService: StatePersistService, private sharedService : SharedService) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const maintenance_mode = environment.maintenanceMode
        const server_env = SharedConsts.SERVER_ALLOWED
        if(server_env.includes(environment.environment) && maintenance_mode && !state.url.includes('/maintenance')){
            this.sharedService.setIpAddress()
        }
        else if (server_env.includes(environment.environment) && maintenance_mode && state.url.includes('/maintenance')){
            return true;
        }
        else if (server_env.includes(environment.environment) && !maintenance_mode && state.url.includes('/maintenance')){
            this.router.navigate(['/home']);
            return false;
        }
        else{
            return true;
        }
    }
}
